jQuery(document).ready(function($) {
    // Get relevant elements and collections
    const tabbed = $('.wp-block-learningsite-tabs');
    const tablist = tabbed.find('h2.tab');
    const tabs = tablist.find('a.tab-heading');
    const panels = tabbed.find('[id^="tab-panel-"]');

    // Add tab panel semantics and hide them all.
    Array.prototype.forEach.call(panels, (panel, i) => {
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('tabindex', '-1');
        panel.hidden = true;
    });

    const activeTab = tabbed.find('h2.tab-active').find('a.tab-heading');
    const activeTabPanel = $(activeTab.attr('href'));

    // Reveal active tab panel if it exists

    setTimeout(function() {
        if (activeTab.length && activeTabPanel.length) {
            // The .tab-active class class is automatically added to the last tab selected in the editor - change it to first tab.
            switchTab(activeTab[0], tabs[0]);
            // Reveal the first tab panel.
            tabs[0].removeAttribute('tabindex');
            tabs[0].setAttribute('aria-selected', 'true');
            panels[0].hidden = false;
        } else if (tabbed.length) {
            // Reveal the first tab panel.
            tabs[0].removeAttribute('tabindex');
            tabs[0].setAttribute('aria-selected', 'true');
            panels[0].hidden = false;
        }
    }, 100);

    // The tab switching function.
    const switchTab = (oldTab, newTab) => {
        // Switch active class.
        $(oldTab).parent().removeClass('tab-active');
        $(newTab).parent().addClass('tab-active');
        // Focus on new tab.
        newTab.focus();
        // Make the active tab focusable by the user (Tab key).
        newTab.removeAttribute('tabindex');
        // Set the selected state
        newTab.setAttribute('aria-selected', 'true');
        oldTab.removeAttribute('aria-selected');
        oldTab.setAttribute('tabindex', '-1');
        // Show new panel, hide old panel.
        let newPanel = $(newTab.getAttribute('href'));
        let oldPanel = $(oldTab.getAttribute('href'));
        oldPanel[0].hidden = true;
        newPanel[0].hidden = false;


        setTimeout(function() {
            // Triggering a resize event on the window will make H5Ps resize.
            window.dispatchEvent(new Event('resize'));
        }, 100);
    }

    // Add semantics and remove user focusability for each tab.
    Array.prototype.forEach.call(tabs, (tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('tabindex', '-1'); // Tabs are accessible through L & R keys, not tab key.

        // Handle clicking of tabs for mouse users.
        tab.addEventListener('click', e => {
            e.preventDefault();
            let currentTab = tabbed.find('h2.tab-active').find('a.tab-heading');
            if (e.currentTarget !== currentTab) {
                switchTab(currentTab[0], e.currentTarget);
            }
        });

        // Handle keydown events for keyboard users.
        tab.addEventListener('keydown', e => {
            // Get the index of the current tab in the tabs node list.
            let index = Array.prototype.indexOf.call(tabs, e.currentTarget);
            // Work out which key the user is pressing and
            // calculate the new tab's index where appropriate.
            let dir = e.which === 37 ? index - 1 : e.which === 39 ? index + 1 : e.which === 40 ? 'down' : null;
            if (dir !== null) {
                e.preventDefault();
                // If the down key is pressed, move focus to the open panel,
                // otherwise switch to the adjacent tab.
                dir === 'down' ? panels[i].focus() : tabs[dir] ? switchTab(e.currentTarget, tabs[dir]) : void 0;
            }
        });
    });
});
